







































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import userSettings from "../components/userSettings.vue";
import teamChange from "../components/teamChange.vue";
import teamPerformanceChart from "../components/team/teamPerformanceChart.vue";
import teamCompletionChart from "../components/team/teamCompletionChart.vue";
import teamEngagementChart from "../components/team/teamEngagementChart.vue";
import teamActivityChart from "../components/team/teamActivityChart.vue";
import { User, UserStat, TeamEngagement } from "../types";
import { Getter } from "vuex-class";

@Component({
  components: {
    userSettings,
    teamChange,
    teamPerformanceChart,
    teamCompletionChart,
    teamEngagementChart,
    teamActivityChart
  },
  beforeRouteEnter(to: any, from: any, next: any) {
    next((vm: any) => {
      console.log(vm.currentTeam.role);
      if (vm.currentTeam.role === 'reviewer') {
        console.log(to);
        next('/review/'+to.params.teamID);
      }
    });
  }
})
export default class Team extends Vue {
  @Prop() private JWT!: string;
  @Getter private currentTeamID!: string;
  @Getter private teamEngagement!: TeamEngagement;
  @Prop() private currentTeam!: any;
  @Prop() private currentTeamUsers!: User[];
  @Prop() private currUser!: User;
  @Prop() private userStats!: UserStat[];
  @Prop() private changeTeam!: (teamID: any) => any
  @Prop() private isValidRoute!: (teamID: any, userID: any) => boolean;

  get totalMembers() {
    return this.currentTeamUsers ? this.currentTeamUsers.length : 0;
  }

  get invitedMembers() {
    if (!this.currentTeamUsers) {
      return 0;
    }
    return this.currentTeamUsers.filter((user) => user.AcceptedOn === null).length;
  }

  get activeLearners() {
    if (this.teamEngagement && this.teamEngagement.ActiveUsers !== null) {
      return this.teamEngagement.ActiveUsers;
    }
    return 0;
  }

  get averageScoreLabel() {
    if (!this.userStats || !this.userStats.length) {
      return "--";
    }
    let total = this.userStats.reduce((sum, stat) => sum + (stat.OverallScore || 0), 0);
    return Math.round(total / this.userStats.length) + "%";
  }
}
